import $ from "jquery"
import swal from "sweetalert"
import axios from "axios"

export const verifyTronTransaction = async(txid) =>{
    return new Promise(async(resolve, reject)=>{
    let i = 0;
    const checkConfirmation = setInterval(()=>{
            window.tronWeb.trx.getUnconfirmedTransactionInfo(txid).then(async(data)=>{
                i++;
                console.log(i, "i")
                if("receipt" in data){
                    if(data.receipt.result === "SUCCESS"){
                        $('.ajax-loader').css("display", "none");
                        setTimeout(() => {
                            swal("Transaction successful", { buttons: false, icon: "success", timer: 2000 });
                        }, 1000);
                        clearInterval(checkConfirmation);
                        resolve(true)
                    }else{
                        $('.ajax-loader').css("display", "none");
                        swal("Transaction Error", { buttons: false, icon: "error", timer: 2000 });
                        clearInterval(checkConfirmation);
                        resolve(false)
                    }
                }else{
                    if(i>15){
                        $('.ajax-loader').css("display", "none");
                        clearInterval(checkConfirmation);
                        resolve(false)
                    }  
                }
            })
        },3000)
        
    })
}

export const fetchTokenDetails = async(web3Obj, address, abi, token) =>{
    return new Promise(async(resolve, reject)=>{
        try{
            const contract = new web3Obj.eth.Contract(abi, token);
            const walletBalance = (await web3Obj.eth.getBalance(address)/10**18).toFixed(4)
            const decimal = await contract.methods.decimals().call()
            const tokenBalance = await contract.methods.balanceOf(address).call()/10**Number(decimal);
            $('.ajax-loader').css("display", "none");
            resolve({walletBalance, decimal, tokenBalance})
        }catch(err){
            resolve(false)
        }
    })
}

export const approveTokenBalance = async (currencyDetails, tokenABI, token, address, totalTokens) => {
    return new Promise(async(resolve, reject)=>{
        const web3 = currencyDetails.web3Obj;
        const contract = new web3.eth.Contract(tokenABI, token);
        const decimal = await contract.methods.decimals().call()
        let UserTokenBalance = await contract.methods.balanceOf(address).call();
        // UserTokenBalance = await web3.utils.fromWei(UserTokenBalance, "ether");
        if (Number(UserTokenBalance)/10**Number(decimal) >= totalTokens) {
            await contract.methods.approve(currencyDetails.airdropAddress, (`${totalTokens * 10 ** Number(decimal) }`)).send({ from: address }, 
                function (err, result) {
                if (err) {     
                    swal("Transaction Error", { buttons: false, icon: "error", timer: 2000 });
                    resolve(false)
                }
                if (result) {
                    swal("Your transaction is sent, Please wait for confirmation.",{ buttons: false, icon: "success", timer: 2000 });
                    setTimeout(() => { $('.ajax-loader').css("display", "flex"); }, 2000);
                }
            }).on('receipt', function (receipt) {
                if (receipt.status === true) {
                    $('.ajax-loader').css("display", "none");
                    setTimeout(() => {
                        swal("Transaction successful", { buttons: false, icon: "success", timer: 2000 });
                    }, 2000);
                    resolve(true)
                } else {
                    $('.ajax-loader').css("display", "none");
                    swal("Transaction Error", { buttons: false, icon: "error", timer: 2000 });
                    resolve(false)
                }
            })
        }
    })  
}

export const  approveTronBalance = async (currencyDetails, token, address, totalTokens) => {
    return new Promise(async(resolve, reject)=>{
        const contract = await window.tronWeb.contract().at(token);
        const decimal = await contract.decimals().call();
        let UserTokenBalance = await contract.balanceOf(address).call();
        let txhash;
        // UserTokenBalance = await web3.utils.fromWei(UserTokenBalance, "ether");
        if (Number(UserTokenBalance)/10**Number(decimal) >= totalTokens) {
            await contract.approve(currencyDetails.airdropAddress, (`${totalTokens * 10 ** Number(decimal) }`)).send({ from: address }, 
                function (err, result) {
                if (err) {     
                    swal("Transaction Error", { buttons: false, icon: "error", timer: 2000 });
                    resolve(false)
                }
                if(result){
                    txhash = result
                    swal("Your transaction is sent, Please wait for confirmation.", { buttons: false, icon: "success", timer: 2000 });
                    setTimeout(() => { $('.ajax-loader').css("display", "flex"); }, 2000); 
                }
            }).then(()=>{
                setTimeout(() => {
                    verifyTronTransaction(txhash).then((isVerified)=>{
                        if(isVerified){
                            resolve(true)
                        }else{
                            resolve(false)
                        }
                    })
                }, 5000);
                
            })
        }
    }) 
}

export const handleApproveTronNft = async(currencyDetails,token, address) => {
    return new Promise(async(resolve, reject)=>{
        const contract = await window.tronWeb.contract().at(token);
        let txhash;
        await contract.methods.setApprovalForAll(currencyDetails.airdropAddress, true).send({ from: address }, 
            function (err, result) {
            if (err) {    
                swal("Transaction Error",{ buttons: false, icon: "error", timer: 2000 });
                resolve(false); 
            }
            if(result){
                txhash = result
                swal("Your transaction is sent, Please wait for confirmation.",{ buttons: false, icon: "success", timer: 2000 });
                setTimeout(() => { $('.ajax-loader').css("display", "flex"); }, 2000);
            }
        }).then(()=>{
            setTimeout(() => {
                verifyTronTransaction(txhash).then((isVerified)=>{
                    if(isVerified){
                        resolve(true)
                    }else{
                        resolve(false)
                    }
                })
            }, 5000);
        })
    })
}

export const handleApproveNft = async(currencyDetails, tokenABI, token, address) => {
    return new Promise(async(resolve, reject)=>{
        const web3 = currencyDetails.web3Obj;
        const contract = new web3.eth.Contract(tokenABI, token);
        await contract.methods.setApprovalForAll(currencyDetails.airdropAddress, true).send({ from: address }, 
            function (err, result) {
            if (err) {     
                swal("Transaction Error",{ buttons: false, icon: "error", timer: 2000 });
                resolve(false);
            }
            if (result) {
                swal("Your transaction is sent, Please wait for confirmation.", { buttons: false, icon: "success", timer: 2000 });
                setTimeout(() => { $('.ajax-loader').css("display", "flex"); }, 2000);
            }
        }).on('receipt', function (receipt) {
            if (receipt.status === true) {
                $('.ajax-loader').css("display", "none");
                setTimeout(() => {
                    swal("Transaction successful",{ buttons: false, icon: "success", timer: 2000 });
                }, 2000);
                resolve(true);
            } else {
                $('.ajax-loader').css("display", "none");
                swal("Transaction Error", { buttons: false, icon: "error", timer: 1000 });
                resolve(false);
            }
        })
    })
    
}

export const fetchTokenABI = async(endPoint, token)=>{
    return new Promise((resolve, reject)=>{
        var config = {
            method: 'get',
            url: `https://${endPoint}/api?module=contract&action=getabi&address=${token}&apikey=P4RYCSQNPMV1RG9J2J7CTVBAESPQS3R4G5`,
            headers: { }
        };

        axios(config)
        .then(async function (response) {
            if(response.data.status === "1"){
                const abi = JSON.parse(response.data.result);
                resolve(abi)  
            }else{
                resolve(false)
            }
        })
    })
}